import type { PlatformRole } from '@drameeka/shared';

/** The three places someone can work. A role belongs to exactly one. */
export type Area = 'staff' | 'studio' | 'developer';

export function areaFor(role: PlatformRole): Area {
  if (role === 'creator') return 'studio';
  if (role === 'developer') return 'developer';
  return 'staff';
}

/** Where each area starts. */
export const AREA_HOME: Record<Area, string> = {
  staff: '/staff',
  studio: '/studio',
  developer: '/developer',
};

export function homeFor(role: PlatformRole): string {
  return AREA_HOME[areaFor(role)];
}

/** Plain-language names for the people using this, not the internal role codes. */
export const ROLE_LABEL: Record<PlatformRole, string> = {
  owner: 'Platform owner',
  admin: 'Platform admin',
  moderator: 'Reviewer',
  support: 'Support',
  creator: 'Creator',
  developer: 'Developer',
};

/** Owners and admins manage people and tenants; everyone else on staff can only look. */
export function canManage(role: PlatformRole): boolean {
  return role === 'owner' || role === 'admin';
}

/** Owners, admins and moderators decide what goes live. */
export function canReview(role: PlatformRole): boolean {
  return role === 'owner' || role === 'admin' || role === 'moderator';
}
